import { useNavigate } from 'react-router-dom'
import { PHASES, TOTAL_DAYS, getEffectiveDayPlan } from '../data/plan'
import { useAllLogs, useProfile, dayNumberFromStartDate, useAiPlan } from '../lib/hooks'

function isDayComplete(log, dayNumber, aiPlan) {
  const plan = getEffectiveDayPlan(dayNumber, aiPlan)
  return plan.exercises.length > 0 && plan.exercises.every((e) => log?.exerciseChecks?.[e.name])
}

function dayStatus(log, dayNumber, currentDay, aiPlan) {
  if (isDayComplete(log, dayNumber, aiPlan)) return 'done'
  const touched =
    log && (log.weightKg != null || Object.keys(log.exerciseChecks || {}).length || Object.keys(log.mealChecks || {}).length || Object.keys(log.supplementChecks || {}).length)
  if (touched) return 'partial'
  if (dayNumber < currentDay) return 'missed'
  if (dayNumber === currentDay) return 'today'
  return 'future'
}

export default function Calendar() {
  const navigate = useNavigate()
  const { logs } = useAllLogs()
  const { profile } = useProfile()
  const { aiPlan } = useAiPlan()
  const currentDay = profile?.startDate ? dayNumberFromStartDate(profile.startDate) : 1

  return (
    <div className="section">
      <span className="plan-eyebrow">● THE PROGRAM</span>
      <h1 className="display-heading" style={{ marginTop: 16 }}>
        Your <span className="display-heading-outline">90</span> Days
      </h1>
      <div className="plan-progress-row">
        <div className="plan-progress-track">
          <div className="plan-progress-fill" style={{ width: `${Math.max((currentDay / TOTAL_DAYS) * 100, 1.1)}%` }} />
        </div>
        <span className="plan-progress-label">{currentDay} / {TOTAL_DAYS}</span>
      </div>

      <div className="phase-grid">
        {PHASES.map((phase) => {
          const isCurrent = currentDay >= phase.startDay && currentDay <= phase.endDay
          return (
            <div key={phase.id} className={`phase-card ${isCurrent ? 'is-current' : ''}`}>
              <div className="phase-card-top">
                <div className="phase-card-meta">
                  <span className="phase-card-range">PHASE {phase.id} · DAYS {phase.startDay}–{phase.endDay}</span>
                  <span className="phase-card-name">{phase.name}</span>
                  <span className="phase-card-split">{phase.split}</span>
                </div>
                <span className="phase-card-num">{phase.id}</span>
              </div>
              <div className="day-grid">
                {Array.from({ length: phase.endDay - phase.startDay + 1 }, (_, i) => phase.startDay + i).map((d) => {
                  const status = dayStatus(logs[d], d, currentDay, aiPlan)
                  return (
                    <button key={d} className={`day-cell status-${status}`} onClick={() => navigate(`/day/${d}`)}>
                      {d}
                    </button>
                  )
                })}
              </div>
            </div>
          )
        })}
      </div>

      <div className="legend">
        <span><i className="dot status-done" style={{ background: 'var(--h-accent)' }} /> Done</span>
        <span><i className="dot status-partial" style={{ background: 'var(--h-accent)' }} /> Partial</span>
        <span><i className="dot status-missed" style={{ background: 'var(--h-danger)' }} /> Missed</span>
        <span><i className="dot" style={{ background: '#fff' }} /> Today</span>
        <span><i className="dot" style={{ background: '#4a4a46' }} /> Upcoming</span>
      </div>
    </div>
  )
}
